var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.774 11.3397C3.192 11.3397 3.53 11.0017 3.53 10.5837V10.5657V8.25269C3.53 5.20969 5.21 3.52969 8.253 3.52969H15.747C18.8 3.52969 20.47 5.20969 20.47 8.25269V15.7527C20.47 18.7957 18.79 20.4667 15.747 20.4667H8.254C5.202 20.4667 3.531 18.7867 3.531 15.7527C3.531 15.3307 3.189 14.9877 2.766 14.9877C2.343 14.9877 2.001 15.3307 2.001 15.7527C2 19.6077 4.392 21.9997 8.244 21.9997H15.747C19.608 21.9997 22 19.6077 22 15.7557V8.25569C22 4.39269 19.608 1.99969 15.747 1.99969H8.254C4.41 1.99969 2 4.39269 2 8.25269V10.5747C1.999 10.9967 2.341 11.3397 2.763 11.3397H2.765H2.774ZM11.2502 7.63349C11.2502 7.21949 11.5862 6.88349 12.0002 6.88349C12.4142 6.88349 12.7502 7.21949 12.7502 7.63349V11.5685L15.7762 13.3725C16.1312 13.5855 16.2482 14.0455 16.0362 14.4015C15.8962 14.6365 15.6462 14.7675 15.3912 14.7675C15.2602 14.7675 15.1282 14.7335 15.0072 14.6615L11.6162 12.6385C11.3892 12.5025 11.2502 12.2575 11.2502 11.9935V7.63349Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeSquare);
export default __webpack_public_path__ + "static/media/Time Square.52015455c87cd7c015a2c45cd59cffd8.svg";
export { ForwardRef as ReactComponent };